var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "box-left",
    attrs: {
      span: 5
    }
  }, _vm._l(_vm.elementBase, function (item, itemIndex) {
    return _c("div", {
      key: itemIndex,
      staticClass: "box-left-group"
    }, [_c("h2", [_vm._v(_vm._s(item.title))]), _c("el-row", {
      attrs: {
        gutter: 20
      }
    }, _vm._l(item.list, function (component, key) {
      return _c("el-col", {
        key: key,
        attrs: {
          span: 12
        }
      }, [_c("el-button", {
        staticClass: "left-button",
        on: {
          click: function click($event) {
            return _vm.addBox(component);
          }
        }
      }, [_vm._v(_vm._s(component.label))])], 1);
    }), 1)], 1);
  }), 0), _c("el-col", {
    staticClass: "box-mid",
    attrs: {
      span: 11
    }
  }, [_c("el-form", {
    attrs: {
      "label-width": "80px",
      size: "small"
    }
  }, [_c("vuedraggable", {
    staticClass: "wrapper",
    on: {
      change: _vm.changeDrag
    },
    model: {
      value: _vm.config,
      callback: function callback($$v) {
        _vm.config = $$v;
      },
      expression: "config"
    }
  }, [_c("transition-group", _vm._l(_vm.config, function (val, key) {
    return _c("div", {
      key: key,
      on: {
        click: function click($event) {
          return _vm.select(key);
        }
      }
    }, [_c("div", {
      staticClass: "box-item",
      class: val.item_id === _vm.index ? "select" : ""
    }, [val.type == "hr" ? _c("el-divider", [_vm._v(_vm._s(val.paramDesc))]) : _c("el-form-item", {
      attrs: {
        label: val.paramDesc,
        required: val.isRequired === 0 ? false : true
      }
    }, [_c("div", [_c("form-item", {
      key: _vm.keyValue,
      attrs: {
        param: val
      },
      model: {
        value: val.value,
        callback: function callback($$v) {
          _vm.$set(val, "value", $$v);
        },
        expression: "val.value"
      }
    })], 1)]), val.item_id == _vm.index ? _c("div", {
      staticClass: "box-delete"
    }, [_c("el-button", {
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.removeBox(key);
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()], 1)]);
  }), 0)], 1)], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.config.length,
      expression: "!config.length"
    }]
  }, [_c("el-empty", {
    attrs: {
      description: "点击组件进行添加"
    }
  })], 1)], 1), _vm.index > 0 ? _c("el-col", {
    staticClass: "box-right",
    attrs: {
      span: 8
    }
  }, [_c("form-param", {
    attrs: {
      param: _vm.updateParam
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };